import {
  EventKind,
  IAnyEvent,
  IAnyTableEvent,
  IBasicEventValue,
  IEventConditionFieldsFragment,
  IEventValue,
  IVirtualEvent,
} from '../../../../utils/apollo/graphqlSchema';
import { UnreachableCaseError } from 'ts-essentials';

const getEventNameByType = (event: IEventValue): string => {
  if (event.kind === EventKind.Basic) {
    return (event as IBasicEventValue).value.name;
  } else if (event.kind === EventKind.Virtual) {
    return (event as IVirtualEvent).name;
  } else if (event.kind === EventKind.Any) {
    return (event as IAnyEvent).name;
  } else if (event.kind === EventKind.AnyTable) {
    return (event as IAnyTableEvent).name;
  } else {
    throw new UnreachableCaseError(event.kind);
  }
};

// Parsing eventConditions and returns a string of joined event names
export default (eventConditions: IEventConditionFieldsFragment[]): string =>
  eventConditions
    .flatMap((ec) => ec.events)
    .map((event) => getEventNameByType(event))
    .join(', ');
